import React from "react"
import "./Card.css"
// import { useState } from "react"
import ModalDetalle from "./ModalDetalle"
import PropTypes from "prop-types"
import {
  MDBCard,
  MDBCardImage,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  // MDBRow,
  MDBCol,
} from "mdb-react-ui-kit"

function Card({
  title,
  imgSource,
  porcentaje,
  paisori,
  ciudad,
  cantciudad,
  cantpais,
  resumen,
}) {
  return (
    <MDBCol>
      <MDBCard className="h-80 ">
        <MDBCardBody>
          <MDBCardTitle className="titulocomida">
            <MDBCardImage className="logoentre" alt="" src={imgSource} />
            <p>{title}</p>
          </MDBCardTitle>

          <MDBCardText className="texto">
            <label
              className="porcentaje"
              style={{ color: porcentaje.includes("-") ? "#58D914" : "red" }}
            >
              {porcentaje}
              {porcentaje.includes("-") ? "▼" : "▲"}
            </label>
          </MDBCardText>
          <MDBCardText className="texto">
            <label className="pais">
              {paisori}: ${cantpais}
              <br />
              {ciudad}: ${cantciudad}
            </label>
          </MDBCardText>
          <MDBCardText className="texto">
            <div>
              <ModalDetalle
                countryName={paisori}
                cityName={ciudad}
                logoSrc={imgSource}
                title={title}
                resumen={resumen}
                mensaje={"ver detalles"}
                ingles={0}
              />
            </div>
          </MDBCardText>
        </MDBCardBody>
      </MDBCard>
    </MDBCol>
  )
}

Card.propTypes = {
  title: PropTypes.string.isRequired,
  imgSource: PropTypes.string,
}

export default Card
